import { JoyLogoLoader } from '@shared/components/JoyLogoLoader';
import { styled } from '@withjoy/joykit';

export const StaticJoyLogoLoader = styled(JoyLogoLoader)`
  position: static;
  height: auto;
`;

export const Centered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`;
